import { DependencyList, useEffect } from 'react'

export const useEventListener = <Event extends keyof WindowEventMap>(
  event: Event,
  callback: (_: WindowEventMap[Event]) => void,
  options?: boolean | AddEventListenerOptions,
  when?: boolean,
  deps: DependencyList = []
) =>
  useEffect((): (() => void) => {
    if (when == undefined || when) window.addEventListener(event, callback, options)
    return () => window.removeEventListener(event, callback, options)
  }, [...(deps || []), when])

export const useEventListeners = <Event extends keyof WindowEventMap>(
  events: Array<Event>,
  callback: (_: WindowEventMap[Event]) => void,
  options?: boolean | AddEventListenerOptions,
  when?: boolean,
  deps: DependencyList = []
) =>
  useEffect((): (() => void) => {
    if (when == undefined || when) events.forEach((event) => window.addEventListener(event, callback, options))
    return () => events.forEach((event) => window.removeEventListener(event, callback, options))
  }, [...(deps || []), when])
